export var error = function error(msg) {
  throw new Error(msg);
};